import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, Key, Download, Clock, Award } from 'lucide-react';
const steps = [{
  icon: ShoppingCart,
  title: 'Comprás'
}, {
  icon: Key,
  title: 'Recibís acceso inmediato'
}, {
  icon: Download,
  title: 'Descargás el material'
}, {
  icon: Clock,
  title: 'Estudiás a tu ritmo'
}, {
  icon: Award,
  title: 'Obtenés tu certificado'
}];
export function HowItWorks() {
  return <section className="py-20 relative z-10" data-id="element-167">
      <div className="container mx-auto px-4" data-id="element-168">
        <motion.div initial={{
        y: 20
      }} whileInView={{
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-169">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-170">
            Así estudiarás
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-171"></div>
        </motion.div>

        <div className="max-w-2xl mx-auto relative" data-id="element-172">
          {/* Vertical Line */}
          <div className="absolute left-8 top-8 bottom-8 w-0.5 bg-mystic-700 md:left-1/2 md:-translate-x-1/2" data-id="element-173"></div>

          <div className="space-y-12" data-id="element-174">
            {steps.map((step, i) => {
            const Icon = step.icon;
            return <motion.div key={i} initial={{
              y: 20
            }} whileInView={{
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.08
            }} className={`relative flex items-center gap-6 md:justify-between ${i % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-175">
                  <div className="hidden md:block md:w-5/12" data-id="element-176"></div>

                  <div className="relative z-10 w-16 h-16 rounded-full bg-mystic-900 border-2 border-gold flex items-center justify-center flex-shrink-0 shadow-gold md:absolute md:left-1/2 md:-translate-x-1/2" data-id="element-177">
                    <Icon className="text-gold" size={24} data-id="element-178" />
                    <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-mystic-800 border border-gold flex items-center justify-center text-xs font-bold text-gold" data-id="element-179">
                      {i + 1}
                    </div>
                  </div>

                  <div className={`md:w-5/12 bg-mystic-800/50 border border-mystic-700 p-6 rounded-xl ${i % 2 === 0 ? 'md:text-left' : 'md:text-right'}`} data-id="element-180">
                    <h3 className="text-xl font-bold text-white" data-id="element-181">
                      {step.title}
                    </h3>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}